import { render, staticRenderFns } from "./create-procedure.vue?vue&type=template&id=fe896ff0&scoped=true&"
import script from "./create-procedure.vue?vue&type=script&lang=js&"
export * from "./create-procedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe896ff0",
  null
  
)

export default component.exports